exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "message{display:block}message>div>div{display:flex;align-items:center}message>div>div span.card-title{margin:0 15px 0 0}message>div>div span.card-title i{vertical-align:middle}", ""]);
